/** @jsxImportSource @emotion/react */
import { useTheme } from "@emotion/react";
import React from "react";
import ContactHeader from "../components/MainComponents/Contact/ContactHeader";
import ContactForm from "../components/MainComponents/Contact/ContactForm";

export default function ContactPage() {
  const theme = useTheme();

  return (
    <>
      <div>
        <ContactHeader />
        <ContactForm />
      </div>
    </>
  );
}
